import { useAuth as useOicdAuth } from 'oidc-react';

type GuardianProfileParams = { guardian_role?: string };

export const useAuth = () => {
  const auth = useOicdAuth();
  const userProfile = auth.userData?.profile;
  const userName = userProfile?.name ?? userProfile?.preferred_username ?? 'User';
  const email = userProfile?.email ?? 'User';
  const guardianRole = (userProfile as { params?: GuardianProfileParams } | undefined)?.params?.guardian_role;

  return {
    accessToken: auth.userData?.access_token,
    idToken: auth.userData?.id_token,
    isAuthenticated: !!auth.userData,
    isLoading: auth.isLoading,
    signIn: auth.signIn,
    signOut: auth.signOutRedirect,
    userName,
    email,
    guardianRole,
  };
};
